import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Guarantee: FunctionalComponent<IIconProps> = ({ width = '24', height = '24', fill = '#458500' }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.37534 11.7191C7.8066 11.3741 8.4359 11.444 8.78091 11.8753L10.1436 13.5787L15.3598 9.23177C15.7841 8.87821 16.4147 8.93553 16.7682 9.35981C17.1218 9.78409 17.0645 10.4147 16.6402 10.7682L10.6455 15.7638C10.6386 15.7696 10.6317 15.7753 10.6247 15.7809C10.1968 16.1233 9.57374 16.057 9.22709 15.6345C9.22364 15.6303 9.22022 15.626 9.21685 15.6218L7.21917 13.1247C6.87416 12.6934 6.94408 12.0641 7.37534 11.7191Z"
        fill={fill}
      />
      <path
        d="M8.73893 3.84686C10.54 2.04582 13.46 2.04582 15.2611 3.84686C15.9098 4.49559 16.8513 4.75639 17.7414 4.53387L19.5843 4.07314C20.3034 3.89337 21 4.43724 21 5.17846V13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13V5.17846C3 4.43724 3.69658 3.89337 4.41567 4.07314L6.2586 4.53387C7.14865 4.75639 8.09019 4.49559 8.73893 3.84686ZM13.8469 5.26107C12.8269 4.24108 11.1731 4.24108 10.1531 5.26107C9.00764 6.40657 7.34513 6.86706 5.77353 6.47416L5 6.28078V13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13V6.28078L18.2265 6.47416C16.6549 6.86706 14.9924 6.40657 13.8469 5.26107Z"
        fill={fill}
      />
    </svg>
  );
};

export default Guarantee;
